import { Card, Pagination } from "antd";
import { ArrowUpRightIcon } from "lucide-react";
import React from "react";
import Lottie from "react-lottie";
import Utils from "../../../utils/Utils";
import Icon from "../../../assets/Icon";
import { Link, useNavigate } from "react-router-dom";
import MockGuidePageNoData from "./MockGuidePageNoData";
import useInterviewExpiry from "../../../hooks/useInterviewExpiry";
import {
  formatDeadline,
  formatDeadlineDay,
} from "../../../utils/interviewExpiry";

function MockGuideCardPage({
  notFoundFlag,
  guideData,
  pageNumber,
  pageSize,
  onPageChange,
  pageCount,
  serverTime,
}) {
  const navigate = useNavigate();
  const stateOf = useInterviewExpiry(guideData, serverTime);

  const handlePageChange = (page) => {
    onPageChange(page);
  };
  console.log(guideData);
  return (
    <div>
      <>
        {!notFoundFlag ? (
          <>
            <div className="mt-4 relative flex flex-col items-center">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-[1rem] gap-x-[1.1rem] w-full">
                {guideData?.length > 0 &&
                  guideData.map((item, index) => (
                    <Card
                      key={index}
                      className="w-full orange-card hover-effect driverjs-alljobs-individual-guide-card"
                    >
                      <div className="min-h-[160px] flex flex-col gap-2 justify-between">
                        <div className="flex flex-col gap-1 pb-2">
                          <div className="flex flex-wrap gap-x-2 gap-y-1 justify-between break-words">
                            <div className="flex-1">
                              <p className="text-[#101828] text-[1.15rem] font-bold leading-[1.55rem]">
                                {item?.jobTitle}
                              </p>
                            </div>
                            <div className="w-[85px]">
                              {stateOf(item) === "INTERVIEW_SCHEDULED" && (
                                <div className="border border-orange-400 bg-orange-100 text-orange-700 rounded-full w-full text-center">
                                  <span className="text font-medium text-[.75rem]">
                                    Scheduled
                                  </span>
                                </div>
                              )}
                              {stateOf(item) === "CONFIGURED" && (
                                <div className="border border-red-400 bg-red-100 text-red-700 rounded-full w-full text-center">
                                  <span className="text font-medium text-[.75rem]">
                                    Configured
                                  </span>
                                </div>
                              )}
                              {stateOf(item) === "INTERVIEW_COMPLETED" && (
                                <div className="active-indicator w-full m-auto ">
                                  <span className="text font-medium text-[.75rem]">
                                    Completed
                                  </span>
                                </div>
                              )}
                              {stateOf(item) === "INTERVIEW_EXPIRED" && (
                                <div className="border border-gray-400 bg-gray-100 text-gray-700 rounded-full w-full text-center">
                                  <span className="text font-medium text-[.75rem]">
                                    Expired
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                          <p className="text-[#101828] font-medium text-[1.02rem]">
                            {item?.companyName} ({item?.yearsOfExperience}+ yrs)
                          </p>
                          <div className="mt-1">
                            <div className="text-[#475467] font-medium text-[0.9rem] mt-[0.12rem]">
                              {item?.blueprintMetadata?.blueprintName}
                            </div>
                            <div className="text-[#475467] font-medium text-[0.9rem] mt-[0.12rem]">
                              {item?.jobLocation || "Location not specified"}
                            </div>
                            <div className="text-[#475467] font-medium text-[0.9rem] mt-[0.12rem]">
                              Created on{" "}
                              <strong>
                                {Utils.converToDateMonthYear(
                                  item?.creationTime,
                                )}
                              </strong>
                            </div>
                            {(stateOf(item) === "INTERVIEW_SCHEDULED" ||
                              stateOf(item) === "INTERVIEW_EXPIRED") &&
                              item?.expiryDate && (
                                <div
                                  className={`font-medium text-[0.9rem] mt-[0.12rem] ${
                                    stateOf(item) === "INTERVIEW_EXPIRED"
                                      ? "text-red-600"
                                      : "text-[#475467]"
                                  }`}
                                >
                                  {stateOf(item) === "INTERVIEW_EXPIRED"
                                    ? `Expired on ${formatDeadlineDay(item.expiresAt, item.expiryDate)}`
                                    : `Valid till ${formatDeadline(item.expiresAt, item.expiryDate)}`}
                                </div>
                              )}
                          </div>
                        </div>
                        {/* <div className="my-1"></div> */}
                        <div className="">
                          <div className="">
                            <div className="mt-auto flex justify-end flex-wrap gap-x-2 items-end ">
                              <Link
                                to={`/schedule-mock-interview?jdIdentifier=${item.jdIdentifier}&iDronaId=${item.idronaInterviewId}`}
                              >
                                <span className="flex items-center gap-2 text-amber-600 font-semibold hover:text-amber-500 text-[0.9rem] cursor-pointer driverjs-all-guide-card-action-link">
                                  {stateOf(item) === "CONFIGURED" &&
                                    "Schedule interview"}
                                  {stateOf(item) === "INTERVIEW_SCHEDULED" &&
                                    "View interview details"}
                                  {stateOf(item) === "INTERVIEW_COMPLETED" &&
                                    "View report"}
                                  {stateOf(item) === "INTERVIEW_EXPIRED" &&
                                    "Reschedule interview"}
                                  <Icon
                                    type="preparation-guide-external-link-icon"
                                    width="16"
                                    height="16"
                                    color="#d97706"
                                  />
                                </span>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>
                  ))}
              </div>

              <Pagination
                className="mt-4"
                current={pageNumber + 1}
                pageSize={pageSize}
                total={pageCount}
                onChange={handlePageChange}
                showSizeChanger={false}
              />
            </div>
          </>
        ) : (
          <MockGuidePageNoData />
        )}
      </>
    </div>
  );
}

export default MockGuideCardPage;
